import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const REVERSE = () => {
  return (
    <CardSection id="REVERSE" title="REVERSE">
      <Paragraph>지정된 문자열을 반전시킵니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>REVERSE(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 반전할 열 값 또는 문자열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>REVERSE(`product`)</Paragraph>
        <Img src="computeReverse" />
      </ListSection>
    </CardSection>
  );
};
